import type { MouseEvent } from 'react';
import React from 'react';
import cx from 'clsx';

import { useLinkComponent } from '~/hooks/mobileApp';
import useNonLoginPopupStore from '~/store/global/useNonLoginPopupStore';

import CartIcon from '~/assets/icons/gnb/ic_cart_line_24x24.svg';
import SearchIcon from '~/assets/icons/gnb/ic_magnifier_line_24x24.svg';
import MypageIcon from '~/assets/icons/gnb/ic_user_line_24x24.svg';
import LocationIcon from '~/assets/icons/ic_location.svg';

interface Props {
  clasName?: string;
  useSearchIcon?: boolean;
  useLocationIcon?: boolean;
  useCartIcon?: boolean;
  useMypageIcon?: boolean;
}
const NonLoginRightMenu = ({
  clasName,
  useSearchIcon,
  useLocationIcon,
  useCartIcon = true,
  useMypageIcon = true,
}: Props) => {
  const LinkComponent = useLinkComponent();
  const { openPopup } = useNonLoginPopupStore();

  const onClick = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();

    openPopup();
  };

  return (
    <div className={cx('flex gap-12 ml-16 text-transparent', clasName)}>
      {useSearchIcon && (
        <LinkComponent href="/search">
          <span>
            <SearchIcon />
          </span>
        </LinkComponent>
      )}
      {useLocationIcon && (
        <div role="presentation" onClick={onClick}>
          <LocationIcon />
        </div>
      )}
      {useCartIcon && (
        <div role="presentation" onClick={onClick}>
          <CartIcon />
        </div>
      )}
      {useMypageIcon && (
        <div role="presentation" onClick={onClick}>
          <MypageIcon />
        </div>
      )}
    </div>
  );
};

export default NonLoginRightMenu;
